import type { RouteLocationNormalized } from 'vue-router'
import { getSentry } from '@myfunnow/web-core/sentry'

import type { LangEnum } from '@/constants/locales'
import { ROUTE_NUMERIC_PARAMS } from '@/constants/pages'

export function getPathWithoutLang(path: string, locale: LangEnum): string {
  let pathWithoutLang = path.startsWith(`/${locale}`) ? path.substring(locale.length + 1) : path
  if (pathWithoutLang.endsWith('/')) {
    pathWithoutLang = pathWithoutLang.slice(0, -1)
  }

  return pathWithoutLang
}

function reportInvalidNumericParam(param: (typeof ROUTE_NUMERIC_PARAMS)[number], paramValue: string, numericValue: string) {
  const sentry = getSentry()

  sentry?.captureMessage('Invalid numeric parameter detected', {
    level: 'warning',
    extra: { param, originalValue: paramValue, extractedValue: numericValue },
  })
}

export function validateRouteNumericParams(to: RouteLocationNormalized) {
  const newParams = { ...to.params }
  let hasInvalidParams = false

  for (const param of ROUTE_NUMERIC_PARAMS) {
    if (!to.params[param]) {
      continue
    }

    const paramValue = to.params[param] as string
    const numericMatch = paramValue.match(/\d+/)

    if (numericMatch) {
      const numericValue = numericMatch[0]

      if (numericValue !== paramValue) {
        reportInvalidNumericParam(param, paramValue, numericValue)
        newParams[param] = numericValue
        hasInvalidParams = true
      }
    } else {
      // 如果完全沒有數字，則到 404 page
      return { shouldRedirect: false, shouldAbort: true }
    }
  }

  // 如果有需要修正的參數，進行重導向
  if (hasInvalidParams) {
    return { shouldRedirect: true, params: newParams }
  }

  return { shouldRedirect: false, shouldAbort: false }
}
